import { render, staticRenderFns } from "./history-component.vue?vue&type=template&id=2cd6b796&scoped=true&"
import script from "./history-component.vue?vue&type=script&lang=js&"
export * from "./history-component.vue?vue&type=script&lang=js&"
import style0 from "./history-component.vue?vue&type=style&index=0&id=2cd6b796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6b796",
  null
  
)

export default component.exports